import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentUser } from '../interface/currentUser.interface';
import { AuthService } from '../services/auth.service';
import { NavigationService } from '../services/navigation.service';
import { WhiteLabelService } from '../services/white-label.service';

@Injectable()
export class Init implements CanActivate {
  constructor(
    private authService: AuthService,
    private navigationService: NavigationService,
    private whiteLabelService: WhiteLabelService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const user: Partial<CurrentUser> | null = this.authService.getUser();
    if (!user) {
      this.router.navigateByUrl(this.whiteLabelService.getLoginRedirectUrl());
      return false;
    }
    if (user.buildings?.length) {
      this.whiteLabelService.setSessionLoginPathFromBuilding(user.buildings[0]);
    }

    const targetRoute = this.navigationService.getTargetRouteForUser(user as any);
    this.router.navigate([targetRoute]);
    return false;
  }
}
